import BackButton from "./BackButton";
import Flex from "../ui/Container/Flex/styled";
import LoggedUser from "./LoggedUser";
import LoginButton from "./LoginButton";
import Nav from "../ui/Nav";
import React from "react";
import Search from "./Search";
import getIdSelector from "../../../state/selectors/ClientSelectors/getIdSelector";
import styled from "styled-components";
import { useSelector } from "react-redux";

const Header = () => {
    const id = useSelector((state: Store) => getIdSelector(state));
    return (
        <Nav primary>
            <FlexLeft grow={1}>
                <BackButton />
            </FlexLeft>
            <Search />
            <FlexRight right grow={1}>
                {!id ? <LoginButton /> : <LoggedUser />}
            </FlexRight>
        </Nav>
    );
};

export default Header;

const FlexLeft = styled(Flex as any)`
    display: flex;
`;

const FlexRight = styled(Flex as any)`
    display: flex;
    justify-content: flex-end;
`;
